<div class="login">
  <mat-card>

    <!-- Seção da LOGO -->
    <div class="logo-container">
      <!-- Substitua o src pela imagem real da sua logo -->
      <img id="logo-simcaq" src="assets/simcaqv2.svg" alt="SIMCAQ">
    </div>


    <!-- Corpo com campos de email e senha -->
    <mat-card-content class="corpo">
      <form>
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input
            matInput
            type="email"
            required
            name="email"
            [(ngModel)]="login.email"
          />
          <mat-icon matSuffix>email</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Senha</mat-label>
          <input
            matInput
            type="password"
            required
            name="senha"
            [(ngModel)]="login.senha"
          />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      </form>

      <div class="texto-direita">
        <a>Esqueci minha senha</a>
      </div>
    </mat-card-content>

    <!-- Ações (botões) -->
    <mat-card-actions class="botoes">
      <button mat-flat-button color="primary" (click)="entrar()">Entrar</button>
      <button mat-flat-button mat-dialog-close (click)="cancelar()">Cancelar</button>
    </mat-card-actions>

  </mat-card>
</div>
